import * as types from './mutations-type'

export default {
  [types.SET_MINI] (state, value) {
    state.mini = value
  },
  [types.TOGGLE_MINI] (state) {
    state.mini = !state.mini
  },
  [types.SET_CUSTOM_MENU_ITEM] (state, { key, item }) {
    // Actualizar navigationRules en lugar de customMenuItems
    state.navigationRules = {
      ...state.navigationRules,
      [key]: item
    }
    // Guardar en localStorage para persistencia
    localStorage.setItem('navigationRules', JSON.stringify(state.navigationRules))
  },
  [types.TOGGLE_MENU_ITEM] (state, key) {
    if (state.disabledMenuItems.includes(key)) {
      state.disabledMenuItems = state.disabledMenuItems.filter(k => k !== key)
    } else {
      state.disabledMenuItems.push(key)
    }
  },
  [types.INIT_NAVIGATION_RULES] (state, rules) {
    state.navigationRules = rules
  },
  [types.SET_DISABLED_ITEMS] (state, items) {
    state.disabledMenuItems = items
  },
  [types.REMOVE_MENU_ITEM] (state, itemId) {
    // Remove item from navigationRules or customMenuItems
    delete state.customMenuItems[itemId]
  },
  [types.UPDATE_MENU_ORDER] (state, orderedItems) {
    state.navigationRules = orderedItems
    // Guardar en localStorage
    localStorage.setItem('navigationRules', JSON.stringify(orderedItems))
  },
  [types.SAVE_NAVIGATION_RULES] (state, rules) {
    state.navigationRules = rules
  }
}
